module.exports = __webpack_public_path__ + "img/join-us-2.f3b95295.png";